import { httpResource } from '@angular/common/http';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DateService } from '../date/date.service';

@Injectable({
  providedIn: 'root',
})
export class NavbarParamService {
  private readonly dateService = inject(DateService);

  triggerHttpRessource: WritableSignal<boolean> = signal(false);

  constructor() {}

  getConnectedUserIdSessionForFormation = httpResource<number>(() => {
    if (!this.triggerHttpRessource()) {
      return undefined;
    }
    return `${environment.apiUrl}/user-account-has-session/connected-user-id-session-for-formation`;
  });

  /**
   * Retrieves a method from the `dateService.method` object based on a string representation of a method call.
   *
   * @param dateServiceCall - A string representing a method call, expected in the format "object.methodName()".
   * @returns The corresponding method from `dateService.method` identified by the extracted method name.
   */
  getDateServiceValue(dateServiceCall: string) {
    dateServiceCall = dateServiceCall.split('.')[1].replace('(', '').replace(')', '');
    return this.dateService.method[dateServiceCall as keyof typeof this.dateService.method];
  }
}
